import React, {Component} from 'react'
import {logout} from '../../actions/login'
import {doPseudoLogout} from '../../actions/users'
import {connect} from 'react-redux'

class Logout extends Component {
  componentWillMount() {
    const {dispatch, profile} = this.props;
    if(profile.attributes['pseudo-login']) {
      dispatch(doPseudoLogout());
    } else {
      dispatch({type: 'CLEAR_PROFILE'});
      dispatch(logout());
    }
  }

  render () {
    if(this.props.processed) {
      if(this.props.profile.attributes['pseudo-login']) {
        window.location.href = `/admin/users/${this.props.profile.id}/details`;
      } else {
        window.location.href = '/login';
      }
    }
    return <p>Loggin out... </p>;
  }

}

export default connect((state) => {
  return {
    processed: state.logout.processed,
    profile: state.viewConfig.profile,
  }
})(Logout);


// WEBPACK FOOTER //
// ./src/components/logout/index.jsx